module.exports = __webpack_public_path__ + "media/images/email-24px-e589bb638b0d80f8c89d347e43d044c2.svg";